import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OPT_TYPE } from "../../../Common/constants";
import { getTranslations } from "../../../Common/utils";
import { getH2HUserRaceWeekWiseSummary } from "../../../Common/utils/league";
import { leaderboard, league } from "../../../redux/actions";
import { Accordion } from "../../Accordion";
import AccordionChild from "../../Accordion/AccordionChild";
import { MatchRecord } from "../../MatchRecord";
import { TableHeader } from "../../TableHeader";
import Head2HeadPreviousRaceScore from "./head2head-previous-race-score";

const H2HSeasonSoFar = ({
  optType,
  gameDayId,
  phaseId,
  handleSeasonSoFarRaceweekClick = () => null,
  handleTabClick = () => null,
}) => {
  const dispatch = useDispatch();
  const leagueState = useSelector((state) => state.league);
  const leaderBoardState = useSelector((state) => state.leaderboard);
  const userState = useSelector((state) => state.user);

  useEffect(() => {
    const payload = {
      guid: userState?.data?.GUID,
      optType: OPT_TYPE,
      leagueId: leagueState?.selectedLeague?.leagueId,
    };

    dispatch(league.getH2HRaceWeekWiseResult(payload));
  }, [dispatch, leagueState?.selectedLeague?.leagueId, userState?.data?.GUID]);

  const [rankActiveIndex, setRankActiveIndex] = useState(0);
  const updateRankActiveIndex = (index, value) => {
    if (!value) {
      setRankActiveIndex(-1);
    } else {
      setRankActiveIndex(index);
    }
  };

  useEffect(() => {
    const getH2HLeaderBoard = () => {
      const payload = {
        guid: userState?.data?.GUID,
        optType: optType,
        leagueId: leagueState?.selectedLeague?.leagueId,
        gameDayId: gameDayId,
        phaseId: phaseId,
        pageNo: 1,
        topNo: 10,
      };
      dispatch(leaderboard.getH2HLeaderBoard(payload));
    };

    getH2HLeaderBoard();
  }, [
    dispatch,
    leagueState?.selectedLeague?.leagueId,
    userState?.data?.GUID,
    optType,
    gameDayId,
    phaseId,
  ]);

  const selectedRaces =
    gameDayId === 0
      ? leagueState?.h2hRaceWeekWiseResultData
      : leagueState?.h2hRaceWeekWiseResultData?.filter(
          (race) => race?.GamedayId == gameDayId
        );

  return (
    <div className="si-battle__grid si-battle__grid--noBg">
      {!!leaderBoardState?.leaderBoard?.length && (
        <div className="si-main__row">
          <div className="si-league__member-box si-league__member-box--self">
            <Accordion
              activeIndex={rankActiveIndex}
              accordionChild={
                <AccordionChild
                  isActive={rankActiveIndex === 0}
                  updateActiveIndex={updateRankActiveIndex}
                  index={0}
                  accordionConfig={{ showAccordRHS: false }}
                  headComponentLHS={
                    <>
                      <h2 className="si-accordion__header">
                        <span>
                          {getTranslations(
                            "league_hth_leaderboard_table_title",
                            "Ranks"
                          )}
                        </span>
                      </h2>
                    </>
                  }
                  bodyComponent={
                    <>
                      <div className="si-league__member-tbl">
                        <TableHeader
                          tableConfig={[
                            {
                              head: getTranslations(
                                "league_hth_leaderboard_table_column_1",
                                "Rank"
                              ),
                              cls: "rank",
                              key: "rank",
                            },
                            {
                              head: getTranslations(
                                "league_hth_leaderboard_table_column_2",
                                "Name"
                              ),
                              cls: "name",
                              key: "teamName",
                            },
                            {
                              head: getTranslations(
                                "league_hth_leaderboard_table_column_3",
                                "Battle Points"
                              ),
                              cls: "pts",
                              key: "points",
                            },
                          ]}
                          tableData={leaderBoardState?.leaderBoard}
                          isHandleClickDisabled={true}
                        />
                      </div>
                    </>
                  }
                />
              }
            />
          </div>
        </div>
      )}
      <MatchRecord
        customCls={"si-matchRecord__wrap--hero"}
        heading={getTranslations("league_hth_season_so_far_summary", "Summary")}
        dataMatchRecord={getH2HUserRaceWeekWiseSummary(leagueState)}
      />
      {selectedRaces?.map((race) => (
        <Head2HeadPreviousRaceScore
          race={race}
          handleSeasonSoFarRaceweekClick={handleSeasonSoFarRaceweekClick}
          handleTabClick={handleTabClick}
        />
      ))}
    </div>
  );
};

export default H2HSeasonSoFar;
